var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{staticClass:"all-trade-tab rounded-0",class:_vm.$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2',attrs:{"elevation":"0"}},[_c('TopPerformedIbTableFilter'),_c('TopPerformedIbTable')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }